import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { X } from 'lucide-react';

const LaunchBanner = () => {
  const { language } = useLanguage();
  const { isDark } = useTheme();
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div
      data-testid="launch-banner"
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[92%] max-w-5xl banner-fade-in"
      style={{ zIndex: 55 }}
    >
      <div className={`relative flex items-center justify-center px-10 md:px-16 py-8 md:py-12 rounded-3xl border-2 backdrop-blur-2xl ${
        isDark
          ? 'bg-[#141414]/80 border-[#D4AF37]/40 shadow-[0_12px_60px_rgba(212,175,55,0.08)]'
          : 'bg-white/70 border-[#D4AF37]/50 shadow-[0_12px_60px_rgba(212,175,55,0.1)]'
      }`}>
        {/* Top gold accent line */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent" />

        {/* Bottom gold accent line */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-28 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />

        {/* Diamond left */}
        <span className="inline-block w-2 h-2 rotate-45 bg-[#D4AF37]/60 mr-5 md:mr-6 flex-shrink-0" />

        {/* Text */}
        <div className="text-center text-[#D4AF37] tracking-wider font-light leading-relaxed">
          {/* Mobile: 3 lines */}
          <p className="block md:hidden text-lg sm:text-xl">
            {language === 'fr' ? 'Bientôt disponible' : 'Coming soon'}
            <br />
            {language === 'fr' ? 'service' : 'service'}
            <br />
            {language === 'fr' ? 'en cours de lancement' : 'launching soon'}
          </p>
          {/* Desktop: 1 line */}
          <p className="hidden md:block text-2xl lg:text-3xl">
            {language === 'fr'
              ? 'Bientôt disponible — service en cours de lancement'
              : 'Coming soon — service launching soon'}
          </p>
        </div>

        {/* Diamond right */}
        <span className="inline-block w-2 h-2 rotate-45 bg-[#D4AF37]/60 ml-5 md:ml-6 flex-shrink-0" />

        {/* Close button */}
        <button
          onClick={() => setIsVisible(false)}
          data-testid="launch-banner-close"
          className={`absolute right-4 md:right-6 top-4 md:top-6 p-2 rounded-full transition-all duration-300 ${
            isDark
              ? 'text-[#D4AF37]/30 hover:text-[#D4AF37]/60 hover:bg-[#D4AF37]/5'
              : 'text-[#D4AF37]/40 hover:text-[#D4AF37]/70 hover:bg-[#D4AF37]/5'
          }`}
          aria-label="Fermer"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default LaunchBanner;